import Box from '@mui/material/Box'
import styled from '@mui/system/styled'

export const StyledContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: 896,
  [theme.breakpoints.down('lg')]: { maxWidth: 672 },
  [theme.breakpoints.down('sm')]: { maxWidth: 343 },
}))
